import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { IconExport } from '@loadsmart/icons'
import { Button, BannerAction } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import ImgCarrierOnboardingRMIS from 'legacy/assets/svg/carrier-onboarding-rmis.svg'
import { I18n } from 'legacy/components/I18n/i18n'
import { screen } from 'legacy/styles/screen'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 248px;
  padding: ${getToken('space-xl')};

  background-color: ${getToken('color-neutral-white')};

  ${screen.md} {
    flex-direction: row;
  }
`

const Main = styled.div`
  margin-top: ${getToken('space-3xl')};
  margin-left: 0;

  ${screen.md} {
    margin-top: 0;
    margin-left: ${getToken('space-3xl')};
  }
`

const Title = styled.h1`
  font-weight: ${getToken('font-weight-bold')};
  font-size: ${getToken('font-size-1')};
`

const Description = styled.p`
  margin: ${getToken('space-m')} 0;

  font-size: ${getToken('font-size-3')};
  line-height: ${getToken('font-height-2')};
`

const StyledIconExport = styled(IconExport)`
  width: ${getToken('font-size-3')};
  height: ${getToken('font-size-3')};
`

const ButtonContent = styled.div`
  display: flex;
`

const StyledCompactIconExport = styled(IconExport)`
  align-self: center;
  width: ${getToken('font-size-5')};
  height: ${getToken('font-size-5')};
`

function RMISPendingBanner(props) {
  const { compact, onClick } = props
  return compact ? (
    <BannerAction
      action={
        <ButtonContent>
          <StyledCompactIconExport />
          &nbsp;
          {I18n.get('lb.RMIS.onboardingBanner.goToRMIS')}
        </ButtonContent>
      }
      onActionButtonClick={onClick}
      title={I18n.get('lb.RMIS.onboardingBanner.title')}
      variant="warning"
    />
  ) : (
    <Container>
      <img src={ImgCarrierOnboardingRMIS} alt="RMIS Onboarding" width="238px" height="189px" />
      <Main>
        <Title>{I18n.get('lb.RMIS.onboardingBanner.title')}</Title>
        <Description>
          {I18n.get('lb.RMIS.onboardingBanner.description')}
          <br />
          <strong>{I18n.get('lb.RMIS.onboardingBanner.estimatedTime')}</strong>
        </Description>
        <Button leading={<StyledIconExport />} onClick={onClick} variant="primary">
          {I18n.get('lb.RMIS.onboardingBanner.goToRMIS')}
        </Button>
      </Main>
    </Container>
  )
}

RMISPendingBanner.propTypes = {
  onClick: PropTypes.func.isRequired,
  compact: PropTypes.bool,
}

RMISPendingBanner.defaultProps = {
  compact: false,
}

export { RMISPendingBanner }
